export namespace animations {
  export const states = {
    entering: {
      opacity: 0.01,
      transform: 'translateZ(0.1px)'
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 1,
      transform: 'translateZ(0.1px)'
    }
  };
}
